type QueuedEvent = { eventName: string; properties: Record<string, unknown> };

const eventQueue: QueuedEvent[] = [];
let klaviyoReady = false;

export function initializeKlaviyo(): void {
  const publicKey = process.env.REACT_APP_KLAVIYO_PUBLIC_KEY;

  if (!publicKey) {
    console.warn('[Klaviyo] Public API key not configured');
    return;
  }

  if (document.getElementById('klaviyo-script')) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'klaviyo-script';
  script.type = 'application/javascript';
  script.async = true;
  script.src = `https://static.klaviyo.com/onsite/js/${publicKey}/klaviyo.js`;
  script.onload = () => {
    waitForKlaviyo(() => {
      klaviyoReady = true;
      identifyKlaviyoUser(window.pgUser?.user_email);
      eventQueue.forEach(({ eventName, properties }) => {
        window.klaviyo?.track(eventName, properties);
      });
      eventQueue.length = 0;
    });
  };

  document.head.appendChild(script);

  // If Klaviyo was already loaded by WordPress, handle it immediately
  if (window.klaviyo) {
    klaviyoReady = true;
    identifyKlaviyoUser(window.pgUser?.user_email);
    eventQueue.forEach(({ eventName, properties }) => {
      window.klaviyo?.track(eventName, properties);
    });
    eventQueue.length = 0;
  }
}

function waitForKlaviyo(callback: () => void, attempts = 0): void {
  if (window.klaviyo) {
    callback();
    return;
  }
  if (attempts < 20) {
    setTimeout(() => waitForKlaviyo(callback, attempts + 1), 100);
  }
}

export function identifyKlaviyoUser(email: string | undefined): void {
  if (!email) {
    return;
  }

  window.klaviyo?.identify({ email });
}

export function trackKlaviyoEvent(
  eventName: string,
  properties: Record<string, unknown> = {}
): void {
  if (!eventName) {
    return;
  }

  if (!klaviyoReady) {
    eventQueue.push({ eventName, properties });
    return;
  }

  window.klaviyo?.track(eventName, properties);
}
